import React from 'react';
import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Home from './pages/Home';
import Thoughts from './pages/Thoughts';
import Projects from './pages/Projects';

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      {/* <Navbar className="navbar"/> */}
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thoughts" element={<Thoughts />} />
          <Route path="/projects" element={<Projects />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;